import { environment } from "@env";
import { Injectable } from "@angular/core";
// import { Socket } from 'ngx-socket-io';
import { Observable, Observer, Subject } from "rxjs";
import { map } from "rxjs/operators";

const CHAT_URL = environment.socketUrl + "?apikey=" + environment.socketApiKey;

export interface Message {
  requestContext?: {
    routeKey: string
  },
  action?: string;
  body: any;
}

@Injectable({
  providedIn: "root",
})
export class SocketService {
  public messages: Subject<Message>;
  private subject: any;

  constructor() {}

  public connect() /*: Subject<MessageEvent>*/ {
    this.messages = this.create(CHAT_URL).pipe(
      map((response: MessageEvent): Message => {
        const data = JSON.parse(response.data);
        return data;
      })
    ) as Subject<Message>;
    // if (!this.subject) {
    //   this.subject = this.create(url);
    // }
    // return this.subject;
  }
  private create(url): Subject<MessageEvent> {
    const ws = new WebSocket(url);
    const observable = Observable.create((obs: Observer<MessageEvent>) => {
      ws.onmessage = obs.next.bind(obs);
      ws.onerror = obs.error.bind(obs);
      ws.onclose = obs.complete.bind(obs);
      return ws.close.bind(ws);
    });

    const observer = {
      next: (data: any) => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify(data));
        }
      },
    };

    this.subject = {
      next: (data: boolean) => {
        ws.close();
      },
    };

    return Subject.create(observer, observable);
  }

  public disconnect() {
    if (this.subject) {
      this.subject.next(true);
      this.subject = undefined;
    }
  }

  // // emit event
  // sendMessage(body: any) {
  //   // this.socket.emit('sendmessage', body);
  // }

  // // listen event
  // onFetchStatus() {
  //   // return this.socket
  //   // return this.socket.fromEvent('sendmessage');
  //   // this.socket.on('connect', () => {
  //   //   this.socket.on('sendmessage', (res) => {
  //   //   });
  //   // });
  // }
}
